export default function ({ store, redirect }) {
	// If the user is not authenticated, redirect to login
	if (!store.state.auth.loggedIn) {
		return redirect('/login');
	}

	// If the user is authenticated but has no user data, redirect to login
	if (!store.state.auth.user) {
		return redirect('/login');
	}

	// Check if user has required privileges data
	if (store.state.auth.user && !store.state.auth.user.Level) {
		console.warn('auth middleware: Usuario sin Level data');
		return redirect('/login');
	}
}
